export default "__VITE_PUBLIC_ASSET__eae17b00__"